import {
	SET_PORTFOLIO_REPORT_ELEMENT_IDS,
} from "./actions/SITE/portfolioActions";

const initialState = {
	_elementListIds: [],
};

const externalHomeReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_PORTFOLIO_REPORT_ELEMENT_IDS:
			return {
				...state,
				_elementListIds: action.payload,
			};
		default:
			return state;
	}
};

export default externalHomeReducer;